import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es7.object.entries.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from 'redux/reducers/cellSets/initialState';

// Stage 2: merge the decoded per-set cellId Sets into the existing properties.
// Never replaces the whole map, so a single-class reload leaves the other
// classes' Sets intact.
var cellIdsLoaded = produce(function (draft, action) {
  var cellIdsBySet = action.payload.cellIdsBySet;
  Object.entries(cellIdsBySet).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      setKey = _ref2[0],
      cellIds = _ref2[1];
    if (!draft.properties[setKey]) {
      // Set present in a blob but not in the hierarchy — skip; the hierarchy is
      // the source of truth for which sets exist.
      return;
    }
    draft.properties[setKey].cellIds = cellIds;
  });
  draft.cellIdsLoaded = true;
}, initialState);
export default cellIdsLoaded;